import React from 'react';
import { Card } from 'react-bootstrap';
import AnimalCoverImage from './AnimalCoverImage';

function AnimalRoomAssignmentCard(props) {

  return (
    <>
    <Card className={"border rounded" + (props.snapshot.isDragging ? " border-danger" : "")} float="left" style={{width:"157px", marginLeft:"-5px", marginTop:props.direction === "horizontal" ? "-5px" : "", whiteSpace:"nowrap", overflow:"hidden"}}>
      <div className="row no-gutters">
        <div style={{whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis"}}>
          <AnimalCoverImage
            animalSpecies={props.animal.species_string}
            height="47px"
            width="47px"
            customStyles={{
              marginRight: '3px',
              float: 'left'
            }}
          />
          {props.animal.animal_count > 1 ? <span title={props.animal.animal_count}>{props.animal.animal_count} <span style={{ textTransform:"capitalize" }}>{props.animal.species_string}</span></span> : <span title={props.animal.name}>
            {props.animal.name||"Unknown Name"}
            </span>}
          <div style={{width:"157px"}}>
            A#{props.animal.id_for_incident}&nbsp;
            <span style={{ textTransform:"capitalize" }}>{props.animal.species_string}&nbsp;</span>
            {/* {props.animal.owner_names.length === 0 ?
            <OverlayTrigger
              key={"stray"}
              placement="top"
              overlay={
                <Tooltip id={`tooltip-stray`}>
                  Animal is stray
                </Tooltip>
              }
            >
              <FontAwesomeIcon icon={faUserAltSlash} size="sm" />
            </OverlayTrigger> :
            <OverlayTrigger
              key={"owners"}
              placement="top"
              overlay={
                <Tooltip id={`tooltip-owners`}>
                  Owners:
                  {props.animal.owner_names.map(owner_name => (
                    <div key={owner_name}>{owner_name}</div>
                  ))}
                </Tooltip>
              }
            >
              <FontAwesomeIcon icon={faUserAlt} size="sm" />
            </OverlayTrigger>} */}
          </div>
        </div>
      </div>
    </Card>
    </>
  );
};

export default AnimalRoomAssignmentCard;
